(function () {
    'use strict';

    Directives.AdyenAddPaymentMethodDirective = function AdyenAddPaymentMethodDirective() {

        class AdyenAddPaymentMethodDirectiveController extends Controllers.BaseControllerES6 {

            // @ngInject
            constructor($scope, $q, $timeout, $translate, $injector,
                        moment, UIUtils, Enums,
                        UsersManager, AdyenCheckout, AnalyticsService, DeviceService, _, Gon) {
                super($scope, $injector);
                this.__objectType = 'AdyenAddPaymentMethodDirectiveController';

                this.$q = $q;
                this.AdyenCheckout = AdyenCheckout;
                this.AnalyticsService = AnalyticsService;
                this.Enums = Enums;
                this.UsersManager = UsersManager;
                this.$translate = $translate;
                this._ = _;

                this.card = {};
                this.getAvailableAdyenPayments();

                this.originKey = Gon.adyen_origin_key_env;

                if (window.location.href.includes("lvh.me")) {
                    this.originKey = Gon.adyen_origin_key_lvh;
                } else if (window.location.href.includes("localhost")) {
                    this.originKey = Gon.adyen_origin_key_localhost;
                }
            }

            getAvailableAdyenPayments() {
                this.UsersManager.getAvailableAdyenPaymentMethods().then(adyen_payments_response => {
                    if (this.disableAch) {
                        adyen_payments_response.data.paymentMethods = adyen_payments_response.data.paymentMethods.filter( el => el.type !== 'ach');
                    }

                    if (this.disableCard) {
                        adyen_payments_response.data.paymentMethods = adyen_payments_response.data.paymentMethods.filter( el => el.type === 'ach');
                    }

                    this.mountAdyenDropin("#adyen-dropin", adyen_payments_response.data);
                });
            }

            mountAdyenDropin(element, adyenPaymentsData) {
                var customHbTranslations = {
                    "en-US": {
                        "payButton": this.payButton,
                        "confirmPurchase": this.confirmPurchaseText
                    }
                };

                const configuration = {
                    locale: "en-US", // The shopper's locale. For a list of supported locales, see https://docs.adyen.com/checkout/components-web/localization-components.
                    environment: "test", // When you're ready to accept live payments, change the value to one of our live environments https://docs.adyen.com/checkout/drop-in-web#testing-your-integration.
                    originKey: this.originKey,
                    translations: customHbTranslations,
                    paymentMethodsResponse: adyenPaymentsData // The payment methods response returned in step 1.
                };

                this.AdyenCheckout.then(function(adyen_sdk) {
                    const checkout = new adyen_sdk(configuration);

                    const dropin = checkout.create('dropin', {
                        paymentMethodsConfiguration: {
                            card: { // Example optional configuration for Cards
                                hasHolderName: true,
                                holderNameRequired: true,
                                hideCVC: false, // Change this to true to hide the CVC field for stored cards
                                name: 'Credit or debit card',
                                data: {
                                    holderName: this.UsersManager.getCurrUser().full_name
                                }
                            }
                        },
                        onSubmit: (state, dropin) => {
                            this.createAdyenPaymentMethod(state.data);
                        },
                    }).mount('#adyen-dropin');
                }.bind(this));
            }

            createAdyenPaymentMethod(paymentData) {
                this.lastError = null;
                const currUser = this.UsersManager.getCurrUser();
                const payment_method_data = {payment_data: paymentData, vendor_id: this.vendorId, card_role: this.cardRole};
                const payment_method_type = paymentData.paymentMethod.type === 'ach' ? this.Enums.PaymentMethodTypes.adyenBankAccount : this.Enums.PaymentMethodTypes.adyenCreditCard;
                const oldPaymentMethods = currUser.payment_methods.map(function (pm) {
                    return pm._id;
                });
                const promise = currUser.addPaymentMethod(payment_method_data, payment_method_type);
                promise.then(() => {
                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.add_new_credit_card, {
                        payment_gateway: "adyen",
                        card_name: paymentData.paymentMethod.holderName
                    });

                    const newPaymentMethod = currUser.payment_methods.map(function (pm) {
                        return pm._id;
                    });
                    const newPaymentMethodId = this._.difference(newPaymentMethod, oldPaymentMethods)[0];

                    if (this.paymentMethodsCount >= 1) {
                        this.successAddCardForm({paymentMethodId: newPaymentMethodId});
                    } else {
                        this.successAddCardAndPay();
                    }
                }).catch(res => {
                    if (res.data && res.data.error_message) {
                        this.lastError = res.data.error_message;
                    } else {
                        this.lastError = this.$translate.instant('ERRORS.SERVER_API._UNEXPECTED_');
                    }
                });
                return promise;
            }
        }

        return {
            restrict: 'E',
            templateUrl: 'angular/app/modules/core/features/workspace_file/payment/adyen_add_payment_method/adyen_add_payment_method_directive_template.html',
            controller: AdyenAddPaymentMethodDirectiveController,
            controllerAs: 'adyenAddPaymentMethodVm',
            bindToController: true,
            scope: {
                paymentMethodsCount: '=',
                vendorId: '=',
                closeAddCardForm: '&',
                successAddCardForm: '&',
                successAddCardAndPay: '&',
                failedAddCardAndPay: '&',
                isAddCardFormValid: '=?isAddCardFormValid',
                disableAch: '=',
                disableCard: '=',
                confirmPurchaseText: '@',
                payButton: '@',
                cardRole: '@'
            }
        };
    };

}());
